<script lang="ts">
  import type { Map as MapType, Maybe, Place } from "../types";
  import type { QueryParams } from "../support/links";
  import { request } from "../data/client";
  import { GetMap } from "../data/schema";
  import { getPlace } from "../domain/map";
  import Drawer from "./drawer.svelte";
  import Map from "../components/map/map.svelte";
  import MapMissing from "../components/map/map-missing.svelte";
  import MapBanner from "../components/map-banner.svelte";
  import { page } from "$app/stores";

  export let activePlaceId: Maybe<string> = null;
  export let expanded = false;
  export let linkBuilder: (query?: QueryParams) => string;
  export let mapId: string;
  export let places: Place[] = [];

  let map: MapType;

  async function load(id: string) {
    const data = await request(fetch, {
      url: $page.url,
      query: GetMap,
      variables: { id }
    });

    map = data.map;

    return map;
  }

  function onToggle() {
    expanded = !expanded;
  }

  function close() {
    expanded = false;
  }

  $: place = map ? getPlace(map, places, activePlaceId) : null;
  $: title = map ? map.title : "Map";
  $: connectionColor = map ? map.connectionColor : "#ff2244";
  $: waypointColor = map ? map.waypointColor : "#ffff00";
  $: backgroundColor = map ? map.backgroundColor : "#111111";
  $: pinColor = map?.pinColor || connectionColor;
</script>

<Drawer
  on:toggle={onToggle}
  {expanded}
  collapsedTitle="Show Detail Map"
  expandedTitle={title}
  style="--background-color: {backgroundColor};
            --connection-color: {connectionColor};
            --pin-color: {pinColor};
            --waypoint-color: {waypointColor};"
>
  {#await load(mapId)}
    <MapMissing message="Loading map…" />
  {:then map}
    <MapBanner {place} {linkBuilder} on:navigate={close} />

    <Map {map} {places} {linkBuilder} {activePlaceId} />
  {:catch}
    <MapMissing message="Unable to load map" />
    <!-- do nothing -->
  {/await}
</Drawer>
